import React, { createContext, useContext, useReducer, useMemo } from 'react';

import { reducer, actions, initialState } from './reducer';

import { Filters, FilterUpdateAction, Actions } from 'modules/Documents/FiltersContext/Filters.interface';

type FiltersContextType = {
    state: Filters;
    actions: Actions;
    dispatch: React.Dispatch<{
        type: string;
        payload: FilterUpdateAction;
    }>;
};

const FiltersContext = createContext<FiltersContextType>({} as FiltersContextType);

export const useFiltersContext = () => useContext(FiltersContext);

interface FiltersContextProviderProps extends FilterUpdateAction {
    children: React.ReactNode;
}

export function FiltersContextProvider({ children, ...props }: FiltersContextProviderProps) {
    const [state, dispatch] = useReducer(reducer, { ...initialState, ...props });
    const value = useMemo(() => ({ state, actions, dispatch }), [state]);

    return <FiltersContext.Provider value={value}>{children}</FiltersContext.Provider>;
}
